// Import dependencies
import React from 'react';

// Import components
import Title from '../../common/title/Title';

// Import CSS & assets
import './Features.css';


const Features_Promoteur = () => (
    <div className="landing__features section__padding">
        <a className="anchor" id="features"></a>
        <div className="landing__solution_title_container" style={{ marginBottom: '20px' }}>
            <Title title="Pourquoi choisir Proplab ?" />
        </div>
        <div className="landing__features_main_container">
            <div className="landing__features_heading">
                <h1 className="gradient__text">Une solution pensée pour les professionnels de l’immobilier</h1>
                <p>Conçu avec et pour les acteurs du développement foncier, Proplab répond aux besoins concrets du terrain :</p>
                <p><strong>analyser vite, juste et avec des données fiables.</strong></p>
            </div>
            <div className="landing__features_container">
                <div className="landing__features_item">
                    <div className="landing__features_item_title" style={{ width: '30%' }}>
                        <Title title="Précision" />
                    </div>
                    <div className="landing__features_item_text" style={{ width: '70%' }}>
                        <p>Proplab s’appuie sur une base de données urbanistiques complète, mise à jour en continu, et sur des algorithmes capables d’interpréter automatiquement les règles du PLU.</p>
                        <p style={{ marginTop: '10px' }}><strong>Résultat : une étude fiable, cohérente et alignée sur les textes réglementaires en vigueur.</strong></p>
                    </div>
                </div>
                <div className="landing__features_item">
                    <div className="landing__features_item_title" style={{ width: '30%' }}>
                        <Title title="Rapidité" />
                    </div>
                    <div className="landing__features_item_text" style={{ width: '70%' }}>
                        <p>Ce que vous faisiez en plusieurs heures peut désormais être réalisé en quelques minutes.</p>
                        <p>Proplab automatise toutes les étapes chronophages de l’analyse foncière : collecte des données contextuelles, lecture du PLU, calcul des capacités et génération du rapport.</p>
                        <p style={{ marginTop: '10px' }}><strong>Vous pouvez multiplier les analyses, accélérer vos études de faisabilité et identifier plus d’opportunités sans effort.</strong></p>
                    </div>
                </div>
                <div className="landing__features_item">
                    <div className="landing__features_item_title" style={{ width: '30%' }}>
                        <Title title="Intelligence" />
                    </div>
                    <div className="landing__features_item_text" style={{ width: '70%' }}>
                        <p>Au-delà du calcul, Proplab contextualise le foncier grâce à l’agrégation de nombreuses données statistiques et territoriales : environnement, densité, desserte, démographie, etc...</p>
                        <p>La plateforme fournit ainsi une vision globale du potentiel d’un site, bien au-delà de sa simple constructibilité.</p>
                        <p style={{ marginTop: '10px' }}><strong>Résultat : une aide à la décision stratégique pour vos équipes de développement, d’investissement ou d’aménagement.</strong></p>
                    </div>
                </div>
                <div className="landing__features_item">
                    <div className="landing__features_item_title" style={{ width: '30%' }}>
                        <Title title="Un partenaire de confiance" />
                    </div>
                    <div className="landing__features_item_text" style={{ width: '70%' }}>
                        <p>Proplab combine expertise métier et excellence technologique.</p>
                        <p>Notre équipe réunit des ingénieurs engagés pour offrir aux acteurs du foncier une solution robuste, évolutive et à la pointe de la donnée urbaine.</p>
                        <p style={{ marginTop: '10px' }}><strong>Nous faisons de la donnée urbaine un véritable levier de performance pour vos projets.</strong></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Features_Promoteur;
